// KVH Link Image
export const kvhLinkIcon = require('../style/icons/logo_KVHLink.svg').default;
